export default __webpack_public_path__ + "static/media/143.fc27106a.gif";